module.exports = __webpack_public_path__ + "img/product-p7_pic@2x.689de9a4.png";